import React from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "@/components/ThemeToggle";
import LanguageToggle from "@/components/LanguageToggle";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/contexts/I18nContext";
import { useAuth } from "@/contexts/AuthContext";

export default function PublicHeader() {
  const { t } = useI18n();
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-8">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <Logo className="h-8 w-8" />
          <span className="font-display text-lg font-bold tracking-tight">
            AI Commerce<span className="text-[hsl(var(--accent))]">OS</span>
          </span>
        </Link>
        <div className="flex items-center gap-1">
          <Link to="/pricing" className="mr-2 hidden text-sm font-medium hover:underline sm:block"
                data-testid="header-pricing-link">
            {t?.("nav.pricing") || "Tarifs"}
          </Link>
          <LanguageToggle />
          <ThemeToggle />
          {user && typeof user === "object" ? (
            <Link to={user.role === "SUPER_ADMIN" ? "/admin" : "/dashboard"}>
              <Button size="sm" data-testid="header-dashboard-btn">
                {t("common.dashboard")}
              </Button>
            </Link>
          ) : (
            <>
              <Link to="/login" className="hidden sm:block">
                <Button variant="ghost" size="sm" data-testid="header-login-btn">
                  {t("common.login")}
                </Button>
              </Link>
              <Link to="/register">
                <Button size="sm" data-testid="header-register-btn">
                  {t("common.register")}
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
